export interface MainFlowData {
  sourceList: sourceList;
  selectedEmailsList: string[];
  contactValue: string;
  isLoading: boolean;
}
export enum MainFlowActionTypes {
  SET_PIN_CHECK_ERROR_FOR_MAIN_FLOW = "[Main Flow] SET_PIN_CHECK_ERROR",
  RESET_PIN_CHECK_ERROR_FOR_MAIN_FLOW = "[Main Flow] RESET_PIN_CHECK_ERROR",
  GET_EMAIL_LIST_FOR_MAIN_FLOW = "[Main Flow] GET_EMAIL_LIST",
  SET_EMAIL_LIST_FOR_MAIN_FLOW = "[Main Flow] SET_EMAIL_LIST",
  CONFIRM_EMAIL_MAIN_FLOW = "[Main Flow] CONFIRM_EMAIL",
  CANCEL_SESSION_MAIN_FLOW = "[Main Flow] CANCEL_SESSION",
  GET_SOURCES = "[Main Flow] GET_SOURCES",
  SET_SOURCES = "[Main Flow] SET_SOURCES",
  CONFIRM_SOURCES = "[Main Flow] CONFIRM_SOURCES",
  SET_BTN_LOADING = "[Main Flow] SET_BTN_LOADING",
  CLEAN_BTN_LOADING = "[Main Flow] CLEAN_BTN_LOADING",
}

export interface MainFlowAction {
  readonly type: MainFlowActionTypes;
  readonly payload: any;
}

export interface sourceList {
  Phone?: string;
  Chat?: string;
}
